import type { h as createVueNode, VNode } from 'vue'

import DashboardShell from '@/components/dashboard/DashboardShell.vue'
import PersistentLayout from '@/layouts/PersistentLayout.vue'

export const dashboardLayout = ((render: typeof createVueNode, page: VNode) =>
  render(PersistentLayout, () => render(DashboardShell, () => page))) as (h: (...args: any[]) => VNode, page: any) => VNode
